{
  "version": 1,
  "asset_id": "3182693d-8fc9-42b1-812d-e029ccdb0ea3",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/3182693d-8fc9-42b1-812d-e029ccdb0ea3/white-metal-roof-crystal-river-fl-640.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/3182693d-8fc9-42b1-812d-e029ccdb0ea3/white-metal-roof-crystal-river-fl-640.avif",
  "original_filename": "white-metal-roof-crystal-river-fl-640.avif",
  "size": 17532,
  "content_type": "image/avif",
  "created_at": "2026-07-16T15:36:12Z"
}
